<template>
    <v-row>
        <v-col cols="12" class="pt-0">
            <v-tabs v-model="currentTab" centered color="black" slider-color="#99CC00" style="">
                <v-tab v-for="tab in tabs" :key="tab" class="tab-text" :href="`#${tab}`">
                    {{ $t(`admin.${tab}`) }}
                </v-tab>
            </v-tabs>
        </v-col>
        <v-col cols="12" v-if="currentTab === 'list_students'">
            <list-students/>
        </v-col>
        <v-col cols="12" v-if="currentTab === 'list_coaches'">
            <list-coaches/>
        </v-col>
    </v-row>
</template>

<script>

import ListCoaches from "@/components/company/ListCoaches";
import ListStudents from "@/components/company/ListStudents";
export default {
    components: {ListStudents, ListCoaches},
    data() {
        return {
            tabs: ['list_students', 'list_coaches'],
            currentTab: 'list_students',
        }
    },
    async mounted() {
        const vm = this
        if(vm.$route?.query?.tab) vm.currentTab = vm.$route.query.tab
    },
}
</script>

<style scoped>

.tab-text {
    color: #333333 !important;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    text-transform: none;
    align-items: end;
    margin-bottom: 4px;
}

</style>
